module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular-aab920.woff";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff
// module id = 792
// module chunks = 2